var bindAction = 'click';
if ('ontouchstart' in document.documentElement) {
	bindAction = 'touchstart';
}

var faGameOverlayOpen = false;

function App() {}

App.wait = function(millis) {
	return new Promise(function(resolve, reject) {
		setTimeout(resolve, millis);
	});
};

App.placeRelatedGames = function(openOverlay) {
	var orientation = App.checkOrientation();
	var $relatedGamesNode = $('.fa-game-overlay .fa-game-relatedGames .inner');

	if(openOverlay === true) {
		$('.fa-game-overlay .fa-game-relatedGames .inner ul').remove();
		var $clonedRelatedGames = $('.game .relatedGames ul').clone();

		// Shuffle items
	    var lis = $clonedRelatedGames.children();
	    while (lis.length) {
	        $clonedRelatedGames.append(lis.splice(Math.floor(Math.random() * lis.length), 1)[0]);
	    }

		$clonedRelatedGames.appendTo($relatedGamesNode);
	}

	var $item = $relatedGamesNode.find('li:first-child()');
	if(orientation == 'landscape') {
		App.setRelatedGamesMaxWidth();

		var relatedGamesHeight = $relatedGamesNode.height();
		var itemMargin = parseInt($item.css('margin-top').replace('px', ''));
		var itemHeight = parseInt($item.height());
		var itemHeightWithMargin = itemHeight + itemMargin;

		// Set button width
		$relatedGamesNode.find('a.home').css('height',itemHeight+'px').css('width',itemHeight+'px');

		var limitItems = Math.floor(relatedGamesHeight/itemHeightWithMargin);
	} else {
		var relatedGamesWidth = $relatedGamesNode.width();
		var itemMargin = parseInt($item.css('margin-left').replace('px', ''));
		var itemWidth = parseInt($item.width());
		var itemWidthWithMargin = itemWidth + itemMargin;

		// Set button width
		$relatedGamesNode.find('a.home').css('width',itemWidth+'px').css('height',itemHeight+'px');

		var limitItems = Math.floor(relatedGamesWidth/itemWidthWithMargin);
	}

	// we show a home button
	limitItems--;

	$relatedGamesNode.find('ul li').css('display: inline-block');
	$relatedGamesNode.find('ul li:nth-of-type(n+'+(limitItems + 1)+')').css('display', 'none');

	if(openOverlay === true) {
		App.lazyload();
	}
};

App.setRanking = function(elm) {
	var rank = 1;
	$(elm).each(function() {
		$(this).find('.rank').html(rank).css('opacity', '1');
		rank++;
	});
};

App.checkOrientation = function() {
	var width = $(window).width(),
		height = $(window).height();

	var orientation = 'portrait';
	$('.fa-game-overlay').removeClass('landscape');
	
	if(detection.is.pc === false && width > height) {
		$('.fa-game-overlay').addClass('landscape');
		orientation = 'landscape';

		$('.fa-game-overlay iframe[name="fa-game-iframe"]').css('width', '90%').css('height', '100%');
		$('.fa-game-overlay .fa-game-relatedGames').css('width', '10%').css('height', '100%');
	} else {
		// Reset limited width
		$('.fa-game-overlay iframe[name="fa-game-iframe"]').css('height', '90%').css('width', '100%');
		$('.fa-game-overlay .fa-game-relatedGames').css('height', '10%').css('width', '100%');
	}

	return orientation;
};

App.setRelatedGamesMaxWidth = function() {
	var maxWidth = 70;
	var windowWidth = $(window).width();
	var $iframeNode = $('.fa-game-overlay iframe[name="fa-game-iframe"]');
	var $relatedGamesNode = $('.fa-game-overlay .fa-game-relatedGames');
	var relatesGamesWidth = $relatedGamesNode.width();

	if(relatesGamesWidth > maxWidth) {
		var iframeWidth = windowWidth - maxWidth;
		$iframeNode.css('width', iframeWidth+'px');
		$relatedGamesNode.css('width', maxWidth+'px');
	}
}

App.showAppTeaser = function(markup) {
	markup = '<div class="fg-appTeaser"><div class="fg-appTeaser-inner"><a href="//play.famobi.com/smarty-bubbles.app/A-BUYHTML5GAMES" target="_blank" class="fg-appTeaser-icon"><img src="https://img.cdn.famobi.com/apps/smarty-bubbles.android/v010/icon.png" alt="" /></a><div class="fg-appTeaser-meta"><div class="titleHolder"><h3><a href="//play.famobi.com/{{packageId}}.app/{{affiliateId}}" target="_blank"><img src="data:image/png;base64,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" alt="" class="storeIcon">Smarty Bubbles App</a></h3><ul class="fg-appTeaser-rating"><li></li><li></li><li></li><li></li><li class="fg-appTeaser-rating-half"></li><li class="ratingCount">479</li></ul></div><div class="ctaHolder"><p>Kostenlose Vollversion!</p><div class="cta"><a href="//play.famobi.com/smarty-bubbles.app/A-BUYHTML5GAMES" target="_blank">Installieren</a></div></div></div><a href="#" class="fg-appTeaser-close"></a></div></div>';

	$('.fa-game-overlay').addClass('withAd').find('.fa-game-relatedGames .inner').append('<div class="fg-appTeaser-container">'+markup+'</div>');
};

App.closeAppTeaser = function() {
	$('.fa-game-overlay .fg-appTeaser-container').remove();
	$('.fa-game-overlay').removeClass('withAd');
};

App.showStoreButtons = function() {
	var buttonShown = false;
	
	if(detection.is.pc) {
		$('[data-store-button]').removeClass('hide');
		buttonShown = true;
	}
	else if(detection.is.android) {
		$('[data-store-button="playstore"]').removeClass('hide');	
		buttonShown = true;
	}
	else if(detection.is.ios) {
		$('[data-store-button="appstore"]').removeClass('hide');	
		buttonShown = true;
	}

	if(buttonShown === true) {
		$('.or, .storeButtons').removeClass('invisible hide');
	}
}

App.lazyload = function() {
	$('img[data-original]').each(function() {
		var $this = $(this);
			
		$this.lazyload({
			threshold: Math.max(200, Math.min(400, parseInt(window.innerHeight / 2))),
			effect: 'fadeIn'
		});
	});
}

App.showOverlay = function(gameUrl) {
	faGameOverlayOpen = true;
	window.scrollTo(0, 0);

	var homeUrl = '/';
	if(isStandalone === true) {
		homeUrl = 'index.html';
	}

	$('body').css('overflow', 'hidden');
	$('body').append('<div class="fa-game-overlay"><iframe seamless="seamless" frameBorder="0" src="'+gameUrl+'" name="fa-game-iframe"></iframe><div class="fa-game-relatedGames"><div class="inner"><a href="'+homeUrl+'" class="home"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 60 60" xml:space="preserve"><g><polygon points="30.96,21.43 15.41,36.98 15.41,50.37 28.72,50.37 28.72,39.22 33.2,39.22 33.2,50.37 46.51,50.37 46.51,36.98"></polygon><polygon points="46.506,26.746 46.506,19.609 42.019,19.609 42.019,22.259 31.01,11.25 30.96,11.3 30.91,11.25 8.44,33.72 12.46,37.75 30.96,19.26 31.04,19.34 49.46,37.75 53.48,33.72"></polygon></g></svg></a></div></div></div>');
	App.placeRelatedGames(true);
};

$(document).ready(function() {
	if($('section.games ul li').length > 0) {
		// Startpage
		App.setRanking('section.games ul li');

		// $('section.games ul li strong').dotdotdot({ });
		// $('section.games ul li .details .description').dotdotdot({ });
	}
	else if($('section.relatedGames').length > 0) {
		// Get game list from startpage
		var categoryUrl = $('[data-navigate-back]').attr('href');

		$.ajax({
			method: "GET",
			url: categoryUrl,
			data: { }
		})
		.done(function(result) {
			var $gamesList = $(result).find('section.games ul');
			$gamesList.find('.header').remove();
			$gamesList.find('.details').remove();

			$gamesList.find('li[data-package-id="'+gamePackageId+'"]').remove();

			var holderContent = '';
			$gamesList.find('li').each(function() {
				$this = $(this);
				$holderContent = $this.find('.holder a');
				$this.find('.holder').remove();
				$this.append($holderContent);
				$this.find('a').removeAttr('class');
			});

			$('section.relatedGames').append($gamesList);

			App.lazyload();

			$('.game .button.cta').removeClass('invisible');
		});
	}

	App.showStoreButtons();
	App.lazyload();
});

$(document).on(bindAction, 'a[data-game-url]', function() {
	var gameUrl = $(this).attr('data-game-url');
	App.showOverlay(gameUrl);

	return false;
});

$(document).on(bindAction, '.fg-appTeaser-close', function() {
	App.closeAppTeaser();

	return false;
});

$(window).resize(function() {
	if(faGameOverlayOpen === true) {
		App.placeRelatedGames();
	}
});